// extracted by mini-css-extract-plugin
export default {"description":"style_description__qN7Dc","fade-in":"style_fade-in__I3mUL","top":"style_top__uptxl","image":"style_image__KyPzP"};